exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageAdminPage__pagination___PMsi_ {\n  text-align: center;\n  margin-top: 20px; }\n\n.manageAdminPage__createButton___3DoYM {\n  float: right;\n  margin-right: 10%; }\n\n.manageAdminPage__table___13fPu {\n  margin-left: 10%;\n  margin-right: 10%;\n  padding-top: 40px; }\n", ""]);

// exports
exports.locals = {
	"pagination": "manageAdminPage__pagination___PMsi_",
	"createButton": "manageAdminPage__createButton___3DoYM",
	"table": "manageAdminPage__table___13fPu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageAdminPage/manageAdminPage.scss
// module id = 1958
// module chunks = 6